import { render } from "./import-resident-dialog.vue?vue&type=template&id=0b1ef1c8&scoped=true&ts=true"
import script from "./import-resident-dialog.vue?vue&type=script&lang=ts"
export * from "./import-resident-dialog.vue?vue&type=script&lang=ts"

import "./import-resident-dialog.vue?vue&type=style&index=0&id=0b1ef1c8&lang=less&scoped=true"
import "./import-resident-dialog.vue?vue&type=style&index=1&id=0b1ef1c8&lang=less"

import exportComponent from "/opt/jenkins/workspace/WF-cloud-admin-beta/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b1ef1c8"]])

export default __exports__